module.exports = __webpack_public_path__ + "img/authors_corner.e92834aa.webp";